module.exports = __webpack_public_path__ + "static/media/icon-play.2e06dcd6.svg";